// src/js/reducers/index.js
import * as types from "../constants/action-types";
import moment from 'moment';

export default function registerLogReducer(state = {}, action) {
  
    switch (action.type) {
       
        case types.LOGOUT:
            return []
        case types.UPDATE_REGISTER_LOG_SUCCESS:
       
            return action.registerlog;

        case types.GET_REGISTER_LOG_SUCCESS:

            return action.registerlog;
           
        case types.LOAD_REGISTER_LOG_SUCCESS:
   
            return action.registerlogs;
       
        case types.DELETE_REGISTER_LOG_SUCCESS:
        
            return action.registerlog;
        
        case types.DELETE_REGISTER_ACCIDENT_SUCCESS:

            var newState = Object.assign({}, state);
            newState.registerAccidents = newState.registerAccidents.filter(incident => incident.registerAccidentId != action.accidentId)
                 
            return newState;

        case types.DELETE_REGISTER_FILE_SUCCESS:

            var newState = Object.assign({}, state);
            newState.files = newState.files.filter(file => file.fileEntryId != action.fileEntryId)
                     
            return newState;
    
        default:
            return state;
    };
};